if (!customElements.get("product-tabs")) {
  class ComponentProductTabs extends HTMLElement {
    constructor() {
      super();

      this.sliderHandlesContent = this.querySelectorAll(
        ".tabs-top-desktop .slider-handle"
      );
      this.sliderHandlesTabs = this.querySelectorAll(
        ".tabs-top-mobile .slider-handle"
      );
      this.tabsMobileWrapper = this.querySelector(
        ".tabs-mobile-wrapper"
      );
      this.carouselContent = null;
      // this.carouselTabs = null;

      this.slidesContentWrapper = this.querySelector(
        ".product-info-tabs .tabs-bottom .keen-slider"
      );
      this.tabsMobile = this.querySelectorAll(
        ".tabs-mobile-wrapper .tab-wrapper"
      );

      this.slidesContent = this.slidesContentWrapper ? this.slidesContentWrapper.children : [];


      /* this.slidesTabsWrapper = this.querySelector(
        ".product-info-tabs .tabs-top-mobile .keen-slider"
      );
      this.slidesTabs = this.slidesTabsWrapper.children; */

      this.effect = "fade";
      this.dots = false;
      this.arrows = false;
      this.autoplay = false;
      this.pauseOnHover = false;
      this.carousel = false;
      this.isInViewPort = false;

      var configContent = {
        mode: "snap",
        loop: false,
        wheel: false,
        dots: this.dots ? this.querySelector(".keen-dots") : false,
        prevButton: this.arrows
          ? this.querySelector(".keen-arrow.prev")
          : false,
        nextButton: this.arrows
          ? this.querySelector(".keen-arrow.next")
          : false,
        customAnimation: this.effect == "fade" ? "fade" : false,
        setContainerHeight: this.effect == "fade",
        autoplay: this.autoplay,
        pauseOnHover: this.pauseOnHover,
        slideChanged: () => {},
      };

      // var configTabs = { ...configContent, slidesPerView: 2.5 };

      // console.log("inited both");
      if (this.sliderHandlesContent[0]) this.sliderHandlesContent[0].parentNode.classList.add("handle-active");
      if (this.sliderHandlesTabs[0]) this.sliderHandlesTabs[0].parentNode.classList.add("handle-active");

      this.tabsMobile.forEach((tab) => {
        tab.addEventListener('click', (e)=>{
          e.preventDefault();
          tab.parentNode.scrollLeft = tab.offsetLeft - 18
        })
      })

      setTimeout(() => {
        this.carouselContent = this.initCarousel(
          this.slidesContent,
          this.slidesContentWrapper,
          configContent
        );
        /* this.carouselTabs = this.initCarousel(
          this.slidesTabs,
          this.slidesTabsWrapper,
          configTabs
        ); */
        this.initTabs(this.carouselContent);
      }, 1);

      //   this.bindCustomizerEvents();
    }

    clearTabs() {
      this.sliderHandlesContent.forEach((sliderHandle) =>
        sliderHandle.parentNode.classList.remove("handle-active")
      );
      this.sliderHandlesTabs.forEach((sliderHandle) =>
        sliderHandle.parentNode.classList.remove("handle-active")
      );
    }

    initTabs(carousel) {
      this.sliderHandlesContent.forEach((sliderHandle) => {
        sliderHandle.addEventListener("click", (event) => {
          event.preventDefault();
          this.clearTabs();
          sliderHandle.parentNode.classList.add("handle-active");
          var numSlide = event.currentTarget.dataset.sliderSlide;
          carousel.moveToSlide(numSlide - 1);

          //this.updateTabPosition(event.currentTarget);
        });
      });
      this.sliderHandlesTabs.forEach((sliderHandle) => {
        sliderHandle.addEventListener("click", (event) => {
          event.preventDefault();
          this.clearTabs();
          sliderHandle.parentNode.classList.add("handle-active");
          var numSlide = event.currentTarget.dataset.sliderSlide;
          carousel.moveToSlide(numSlide - 1);

          this.updateTabPosition(event.target);
        });
      });
    }

    updateTabPosition(tab){
      this.tabsMobileWrapper.scrollBy({
        left: tab.getBoundingClientRect().left - this.tabsMobileWrapper.getBoundingClientRect().left - 1,
        top: 0,
        behavior: 'smooth'
      })
    }

    initCarousel(slides, wrapper, config) {
      if (slides.length > 1) {
        return new KeenSlider(wrapper, config);
      } else {
        if (wrapper) wrapper.classList.add("initialized");
      }
    }

    getCurrentSlide() {
      if (this.carousel && this.carousel.currentSlide()) {
        return this.carousel.currentSlide();
      } else {
        return this.slidesWrapper.firstChild;
      }
    }

    bindCustomizerEvents() {
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener("shopify:block:select", (e) => {
          let index = Array.from(this.slides).findIndex((x) => x == e.target);
          if (index >= 0) {
            setTimeout(() => {
              this.carousel.moveToSlideRelative(index, true, 0);
            }, 10);
          }
        });
      }
    }
  }
  customElements.define("product-tabs", ComponentProductTabs);
}
